import React, { Component } from "react";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';

export default class PageSplash extends Component {
	
	constructor(){
		super()
		this.state = {
			exterior: 	true
		}
		this.handleToggle = this.handleToggle.bind(this);
	}
    
    handleToggle(_el) { 
	    console.log('this.state.exterior: ' + this.state.exterior); 
	    if (this.state.exterior == true) {
	    	this.setState({ exterior : false });
	    } else {
		    this.setState({ exterior : true });
	    }
    }
  	
	render () {
		
		let block = this.props.block;
		
		if (block) {
						
		    return (
			    
				<div className="c-page__block c-page__block--splash">
					
					<div className="c-splash">
						
						<div className="c-splash__landscape">
							
							{block.lan_src &&
								<Image src={block.lan_src} srcset={block.lan_srcset} />
							}
						
						</div>
						
						<div className="c-splash__portrait">
							
							{block.por_src &&
								<Image src={block.por_src} srcset={block.por_srcset} />
							}
						
						</div>
						
						<div className="c-splash__overlay" style={{opacity:block.overlay_opacity/100}}></div>
						
						{block.subheading &&
							<h1 className="c-splash__heading c-splash__heading--large" dangerouslySetInnerHTML={{__html:block.heading}}></h1>
						}
						{block.icon == 'square' &&
							<h1 className="c-splash__heading" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><rect width="4" height="4"/></svg><span>' + block.heading + '</span>'}}></h1>
						}
						
						{block.icon == 'circle' &&
							<h1 className="c-splash__heading" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><circle cx="2" cy="2" r="2"/></svg><span>' + block.heading + '</span>'}}></h1>
						}
						
						{block.icon == 'hexagon' &&
							<h1 className="c-splash__heading" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><polygon style="fill:#FFFFFF;" points="3,0.3 1,0.3 0,2 1,3.7 3,3.7 4,2 "/></svg><span>' + block.heading + '</span>'}}></h1>
						}
						
						{block.subheading &&
							<h1 className="c-splash__subheading" dangerouslySetInnerHTML={{__html:block.subheading}}></h1>
						}
						
					</div>	
					
				</div>
				
			)
			
		} else {
			
			return null;
		
		}
	}
}
